import React from 'react'
import className from "classnames"



export default function Img({onClick,rectangular,square,bigsquare, square_with_outline,stat_square,charIcon,footer,smallfooter,socialmedia,aboutus_ins,aboutus_livedhere,aboutus_idsc,bigrectangular,char,charIcon2,charIcon3,src, alt, ...rest}) {

  const classes = className('',{
    'w-[140px] h-[110px] border border-amber rounded-[10px] overflow-hidden inline-block mx-1.5':rectangular,
    // rectangularStyle :rectangular,
    'w-[125px] h-[154px] md:w-[355px] md:h-[384px] p-1 md:p-2 border border-amber rounded-[8px] overflow-hidden':square_with_outline,
    
    'w-[138px] md:w-[208px] lg:w-[238px] h-[105px] md:h-[145px] border border-amber rounded-[8px] overflow-hidden':square,
    
    'w-[300px] h-[204px] md:w-[448px] md:h-[304px] lg:w-[548px] lg:h-[304px] rounded-[8px] overflow-hidden':bigsquare,
    
    'w-full h-[200px] md:h-[500px] rounded-[8px] overflow-hidden bg-red-400':bigrectangular,
    // 'w-[366px] h-[245px] border border-amber rounded-ss-[8px] rounded-se-[8px] overflow-hidden':stat_square,
    // 'w-[90px] sm:w-[266px] md:w-[300px] lg:w-[366px] xl:w-[366px] h-[80px] sm:h-[180px] md:h-[240px] lg:h-[245px] border border-amber rounded-ss-[8px] rounded-se-[8px] overflow-hidden':stat_square,
    'w-full h-[80px] sm:h-[180px] md:h-[240px] lg:h-[245px] border border-amber rounded-ss-[8px] rounded-se-[8px] overflow-hidden':stat_square,
    'w-[100px] lg:w-[150px]': footer,
    'w-[70px]': smallfooter,
    'h-7 w-7 shrink-0 overflow-hidden md:h-auto md:w-[35px]': socialmedia,
    
    'w-[105px] md:w-[180px]':aboutus_idsc,
    'w-[120px] md:w-[220px]':aboutus_livedhere,
    'w-[75px] md:w-[115px]':aboutus_ins,
    
    'w-[88px] md:w-[208px] lg:w-[238px] h-[145px] md:h-[285px] border border-amber rounded-[8px] overflow-hidden': char,   
    'w-[20px] lg:w-[40px]':charIcon, 
    'w-[30px] md:w-[50px]':charIcon2, 
    'w-[15px] md:w-[30px]':charIcon3, 
    
  })

  const classes_img = className('',{
    'w-full h-full object-cover': square || bigsquare || stat_square || char || bigrectangular,
    'w-full h-full object-contain': socialmedia,
    'h-auto w-full object-contain': aboutus_livedhere,
    'w-full h-full object-contian':rectangular,
    'w-full h-full object-cover rounded-[8px]':square_with_outline,
    '':stat_square,
  })

  return (
    <div className={classes} onClick={onClick}> 
        <img
            src={src}
            alt={alt}
            {...rest}
            className={classes_img}
            
        />
    </div>
  )
}
